import { connect } from "react-redux";
import isEmpty from "lodash.isempty";
import forgotPasswordActions from "ducks/forgotPassword";
import loginRegisterActions from "ducks/loginRegister";
import appPath from "utils/appPath";
import { browserHistory } from "react-router";
import Message from "utils/Message";
import { SCREENS } from "common/constants/Constants";
import { setThinking, doneThinking } from "ducks/thinking";

export function createMapStateToProps() {
    return (state) => {
        const {
            forgotPassword = {},
            loginRegister = {},
            routing,
            thinking
        } = state;

        const redirectTo = routing && routing.locationBeforeTransitions && routing.locationBeforeTransitions.query.redirectTo;

        return {
            thinking,
            success: forgotPassword.success,
            errors: isEmpty(forgotPassword.errors) ? loginRegister.errors : forgotPassword.errors,
            bloombergSiteUrl: state.config.bloombergSiteUrl,
            email: loginRegister.email,
            password: loginRegister.password,
            backLink: redirectTo || appPath.withIframePrefix(SCREENS.SIGN_IN),
            grecaptchaApiKey: state.config.grecaptchaApiKey,
            useRecaptcha: loginRegister.useRecaptcha
        };
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        onEmailChange(newEmail) {
            return dispatch(loginRegisterActions.emailChange(newEmail));
        },

        forgotPassword(email, isResend, captcha) {
            dispatch(setThinking());

            return dispatch(forgotPasswordActions.forgotPassword(email, "", captcha))
                .then(() => {
                    if (isResend) {
                        browserHistory.push(appPath.withIframePrefix(SCREENS.EMAIL_RESENT));
                    }
                })
                .then(() => dispatch(doneThinking()))
                .catch(() => dispatch(doneThinking()));
        },

        socialLogin(socialSite) {
            const onSocialLogin = (user) => {
                if (appPath.isIframePath()) {
                    Message.userSignedIn(user);
                    Message.closeWindow();

                    return;
                }

                return browserHistory.push(appPath(SCREENS.ACCOUNT));
            };

            dispatch(setThinking());

            return dispatch(loginRegisterActions.socialLogin(socialSite))
                .then((user) => onSocialLogin(user))
                .then(() => dispatch(doneThinking()))
                .catch(() => dispatch(doneThinking()));
        }
    };
}

function createForgotPasswordContainer(component) {
    return connect(
        createMapStateToProps(),
        mapDispatchToProps
    )(component);
}

export default createForgotPasswordContainer;
